import React, { useEffect, useState } from 'react';
import api, { fmtNum, fmtDate } from '@/lib/api';
import { Loading, EmptyState, StatusBadge } from '@/components/Shared';

export default function DriverHistory() {
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get('/driver/deliveries').then((r) => setOrders(r.data)); }, []);
  if (!orders) return <Loading />;
  const done = orders.filter((o) => ['completed', 'invoice_generated'].includes(o.status));
  return (
    <div className="space-y-3">
      <h2 className="font-display text-lg font-semibold">Delivery History</h2>
      {done.length === 0 ? <EmptyState title="No completed deliveries yet" /> : done.map((o) => (
        <div key={o.id} className="rounded-xl border border-border bg-card p-3 flex items-center justify-between">
          <div><p className="font-medium text-sm">{o.order_no}</p><p className="text-xs text-muted-foreground">{o.customer_name} · {fmtNum(o.pricing.qty)} {o.pricing.unit} · {fmtDate(o.created_at)}</p></div>
          <StatusBadge status={o.status} label={o.status_label} />
        </div>
      ))}
    </div>
  );
}
